// 统一状态
export const SPEECH_STATE = {
    IDLE: "idle",
    CONNECTING: "connecting",
    READY: "ready",
    RECORDING: "recording",
    STOPPING: "stopping",
    CLOSED: "closed",
    ERROR: "error"
};

// 音频默认参数
export const AUDIO_CONFIG = {
    sampleRate: 16000,
    bitRate: 16,
    numChannels: 1
};

// 阿里云事件名称
export const ALI_EVENT = {
    STARTED: "TranscriptionStarted",
    RESULT_CHANGED: "TranscriptionResultChanged",
    SENTENCE_END: "SentenceEnd",
    COMPLETED: "TranscriptionCompleted"
};

export const ALI_WEBSOCKET_URL = {
    URL: "wss://nls-gateway.cn-shanghai.aliyuncs.com/ws/v1",
}

export const APP_KEY = "hPZ4gJ9rZpYthxX7";
export const DEFAULT_MIN_DURATION = 1000 // 最大录音时长